import { render, staticRenderFns } from "./order-detail-box.vue?vue&type=template&id=015d68ac&scoped=true&"
import script from "./order-detail-box.vue?vue&type=script&lang=js&"
export * from "./order-detail-box.vue?vue&type=script&lang=js&"
import style0 from "./order-detail-box.vue?vue&type=style&index=0&id=015d68ac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d68ac",
  null
  
)

export default component.exports